/* @jsx h */

const Loading = () => (
  <div className="spinner">
    <svg
      className="spinner__icon"
      viewbox="0 0 66 66"
      focusable="false"
      role="img"
    >
      <title>Spinner</title>
      <circle
        fill="none"
        stroke-width="6"
        stroke-linecap="round"
        cx="33"
        cy="33"
        r="30"
      />
    </svg>
    <span class="sr-only">Inhalte werden geladen ...</span>
  </div>
);

export default Loading;
